export function buildVirtualOccurrenceWorkOrder(activity, occurrenceDate, guestReservation = null) {
  return {
    isVirtual: true,
    occurrence_key: activity?.occurrenceKey || null,
    task_recurrence_rule_id: activity?.taskRecurrenceRuleId || null,
    rental_id: Number(activity?.homeId) || null,
    guest_reservation_id: activity?.guestReservationId || null,
    guest_reservation: guestReservation || activity?.guest_reservation || null,
    scheduled_date: occurrenceDate || null,
    scheduled_start_time: activity?.scheduledStartTime || null,
    scheduled_end_time: activity?.scheduledEndTime || null,
    summary: activity?.label || "",
    task_type: activity?.taskType || activity?.type,
    priority: activity?.priority || "medium",
    category: activity?.category || null,
    task_source: "recurrence",
    status: "new",
  };
}
